import Vue from 'vue'
import App from './App.vue'
import 'typeface-comfortaa'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')